var React = require('react');

function Icon4 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-4 {\n        fill: #fff;\n      }\n    ")),React.createElement("g",{"id":"_Слой_1-2","data-name":"Слой 1","key":1},React.createElement("path",{"className":"cls-4","d":"M52.42,1.85c1.25,2.17,1.56,4.75,.88,7.19-.69,2.44-2.32,4.53-4.54,5.81l-11.74,6.78-2.29-3.97,5.34-3.08-4.32-7.48L0,27.74l4.3,7.45,5.34-3.08,2.31,4L1.19,42.32l1.8,3.12L50.56,17.98c3.07-1.78,5.32-4.67,6.27-8.04,.95-3.37,.51-6.94-1.21-9.94l-3.2,1.85ZM12.8,30.27l18.74-10.82,2.31,4.01-18.74,10.82-2.31-4.01Z"}))]);
}

Icon4.defaultProps = {"id":"_Слой_2","data-name":"Слой 2","viewBox":"0 0 57.32 45.44"};

module.exports = Icon4;

Icon4.default = Icon4;
